import * as React from "react";
import { Route, Switch } from "react-router";

import RockCalculator from "./components/pages/RockCalculator";
import NotFoundPage from "./components/pages/NotFoundPage";

import "./custom.css"

export default () => (
    <Switch>
        <Route exact key="root" path="/" component={RockCalculator}/>
        <Route component={NotFoundPage} />
    </Switch>
    );